import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

// Components
import ErrorDialog from "../../utils/dialogs/ErrorDialog";
import FaqItemAdmin from "./FaqItemAdmin";
import DeleteConfirmationDialog from "../../utils/dialogs/DeleteConfirmationDialog";
import Button from "../../utils/Button";
import AddNewFaqDialog from "../../utils/dialogs/AddNewFaqDialog";

// State
import { userTokenUpdate } from "../../../store/actions/user";

// Utils
import { getAuthHeader } from "../../../store/headers";

class SearchFaq extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.items,
			showErrorDialog: false,
			showDeleteConfirmationDialog: false,
			deleteItem: {},
			addNewLoading: false,
			showNewItemDialog: false
		};
	}

	// ===================================================================================
	//  INPUT HANDLERS
	// ===================================================================================
	updateQuestion = (event, index) => {
		const { id, value } = event.target;

		this.setState({
			data: [
				...this.state.data.map((item, i) => {
					if (i !== index) {
						return item;
					}

					return {
						...item,
						[id]: value,
						titleChanged: true
					};
				})
			]
		});
	};

	editorChange = (event, id, index) => {
		const newContent = event.editor.getData();

		// If the editor hasn't actually changed, bail!
		// This get's triggered for whatever reason after an item is added/deleted.
		if ((newContent, this.state.data[index][id])) return false;

		this.setState({
			data: [
				...this.state.data.map((item, i) => {
					if (i !== index) {
						return item;
					}

					return {
						...item,
						[id]: newContent,
						titleChanged: true
					};
				})
			]
		});
	};

	updateCheckboxArray = (event, index) => {
		const { name } = event.target;

		let newState = [
			...this.state.data.map((item, i) => {
				if (i !== index) return item;

				return {
					...item,
					[name]: !item[name],
					titleChanged: true
				};
			})
		];

		this.setState({
			data: newState
		});
	};

	// ===================================================================================
	//  ADD
	// ===================================================================================
	addNewItem = args => {
		const { question, answer, restricted } = args;

		this.setState(
			{
				newItemInProgress: true,
				newItemError: null
			},
			() => {
				const { user } = this.props;
				const data = { question, answer, restricted };

				return axios
					.post(process.env.REACT_APP_API_URL + "faq/add", data, {
						headers: getAuthHeader(user, true)
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								newItemInProgress: false,
								newItemError: response.data.errors
							});
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Hide "new item" dialog, reset any flags, and add the new item to state
							this.setState({
								newItemInProgress: false,
								showNewItemDialog: false,
								data: [response.data.faq, ...this.state.data]
							});
						}
					})
					.catch(err => {
						this.setState({
							newItemInProgress: false,
							newItemError: err.toString()
						});
					});
			}
		);
	};

	// ===================================================================================
	//  UPDATE
	// ===================================================================================
	handleUpdate = editedItem => {
		let itemIndex = null;

		// Set state of saving group
		const savedDocState = this.state.data.map((item, i) => {
			if (item.id !== editedItem.id) {
				return item;
			}

			itemIndex = i;

			return { ...item, saving: true, successfull: false };
		});

		this.setState(
			{
				data: [...savedDocState]
			},
			() => {
				const { user } = this.props;
				const data = { ...editedItem };

				return axios
					.post(process.env.REACT_APP_API_URL + "faq", data, {
						headers: getAuthHeader(user, true)
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								showErrorDialog: true,
								errors: response.data.errors
							});

							this.resetItemState(itemIndex);
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Reset saving status for group
							this.resetItemState(itemIndex, true);
						}
					})
					.catch(err => {
						this.setState({
							showErrorDialog: true,
							errors: err.toString()
						});
						this.resetItemState(itemIndex);
					});
			}
		);
	};

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete = itemId => {
		let itemIndex = null;

		// Set state of saving group
		const savedDocState = this.state.data.map((item, i) => {
			if (item.id !== itemId) {
				return item;
			}

			itemIndex = i;

			return { ...item, deleting: true };
		});

		this.setState(
			{
				data: [...savedDocState],
				deleteItem: {
					...this.state.deleteItem,
					deletionInProgress: true
				}
			},
			() => {
				const { user } = this.props;

				return axios
					.delete(process.env.REACT_APP_API_URL + `faq/${itemId}`, {
						headers: getAuthHeader(user, true)
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								deleteItem: {
									...this.state.deleteItem,
									deletionInProgress: false,
									deleteErrors: {
										...response.data.errors
									}
								}
							});

							this.resetItemState(itemIndex);
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Remove deleted group from local state
							// Also set success message and reset deletion stuffs
							this.setState({
								data: [...this.state.data.filter(item => item.id !== itemId)],
								deleteSuccess: response.data.message,
								deleteItem: {}
							});
						}
					})
					.catch(err => {
						this.setState({
							deleteItem: {
								...this.state.deleteItem,
								deletionInProgress: false,
								deleteErrors: err.toString()
							}
						});
						this.resetItemState(itemIndex);
					});
			}
		);
	};

	resetItemState = (itemIndex, successfull = false) => {
		this.setState({
			data: [
				...this.state.data.map((deleteItem, i) => {
					if (i !== itemIndex) {
						return deleteItem;
					}

					return {
						...deleteItem,
						saving: false,
						deleting: false,
						successfull,
						titleChanged: !successfull
					};
				})
			]
		});
	};

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<div className="searchbar-with-button-content">
				<Button
					text={"Add New"}
					clickHandler={() =>
						this.setState({
							showNewItemDialog: true
						})
					}
					isLoading={this.state.newItemInProgress}
					isDisabled={this.state.newItemInProgress}
					classes={"searchbar-bottom-btn"}
				/>
				<div className="searchbar-with-button-content--content">
					{this.state.data.length ? (
						<div>
							{this.state.data.map((item, i) => (
								<FaqItemAdmin
									key={i}
									item={item}
									titleChanged={this.titleChanged}
									handleInputChange={e => this.updateQuestion(e, i)}
									handleCheckboxClick={e => this.updateCheckboxArray(e, i)}
									editorChange={(e, id) => this.editorChange(e, id, i)}
									handleSubmit={() => this.handleUpdate(item)}
									deleteItem={() => {
										this.setState({
											showDeleteConfirmationDialog: true,
											deleteItem: item
										});
									}}
								/>
							))}
						</div>
					) : (
						<div>No Results</div>
					)}
					<ErrorDialog
						show={this.state.showErrorDialog}
						errors={this.state.errors}
						handleClose={() => this.setState({ showErrorDialog: false })}
					/>
					<AddNewFaqDialog
						show={this.state.showNewItemDialog}
						inProgress={this.state.newItemInProgress}
						handleAdd={this.addNewItem}
						handleClose={() =>
							this.setState({
								showNewItemDialog: false,
								addSuccess: null,
								newItemError: null
							})
						}
						errors={this.state.newItemError}
						success={this.state.newItemSuccess}
					/>
					<DeleteConfirmationDialog
						show={this.state.showDeleteConfirmationDialog}
						deletionInProgress={this.state.deleteItem.deletionInProgress}
						id={this.state.deleteItem.id}
						itemTitle={this.state.deleteItem.title}
						handleDelete={this.handleDelete}
						handleClose={() =>
							this.setState({
								showDeleteConfirmationDialog: false,
								deleteSuccess: null,
								deleteItem: {}
							})
						}
						deleteErrors={this.state.deleteItem.deleteErrors}
						deleteSuccess={this.state.deleteSuccess}
					/>
				</div>
			</div>
		);
	}
}

SearchFaq.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

const mapStateToProps = state => {
	return {
		user: state.user
	};
};

export default connect(
	mapStateToProps,
	{ userTokenUpdate }
)(SearchFaq);



// WEBPACK FOOTER //
// ./src/components/admin/faq/SearchFaq.js